import React from 'react';
import { Mail, Phone, Linkedin, Globe, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    'Market Research & Business Intelligence',
    'Student Support & Mentorship',
    'Business Cases & Corporate Presentations',
    'Startup Pitch Decks',
    'Consulting & AI Roadmaps'
  ];

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Careers', href: '#careers' },
    { name: 'Contact', href: '#contact' },
    { name: 'Book Consultation', href: '#booking-form' }
  ];

  return (
    <footer className="bg-gradient-to-br from-[#1e1919] to-[#2d2728] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_7be45cf1-2732-4548-9b9b-de308b396d7f/artifacts/1xjolion_Logo%20Knowledge%20Ninja.PNG" 
                alt="Knowledge Ninja Lab" 
                className="h-10 w-auto filter brightness-110"
              />
              <h3 className="text-xl font-bold font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">Knowledge Ninja Lab</h3>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Your sharp edge in market & business intelligence. Empowering students, startups, and corporates with actionable insights and strategic growth support.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:info@knowledgeninjalabs.com" className="text-[#5f9dff] hover:text-white transition-colors duration-200">
                <Mail className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/in/knowledge-ninja-0b24b8372/" className="text-[#5f9dff] hover:text-white transition-colors duration-200">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://medium.com/@info.knowledgeninjalab" className="text-[#5f9dff] hover:text-white transition-colors duration-200">
                <Globe className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services Section */}
          <div className="lg:col-span-1">
            <h4 className="text-lg font-semibold mb-6 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a 
                    href={`#service-${index}`} 
                    className="text-gray-300 hover:text-[#5f9dff] transition-colors duration-200 text-sm leading-relaxed"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-1">
            <h4 className="text-lg font-semibold mb-6 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href} 
                    className="text-gray-300 hover:text-[#5f9dff] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-1">
            <h4 className="text-lg font-semibold mb-6 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">Get in Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#5f9dff] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@knowledgeninjalabs.com" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm">
                  info@knowledgeninjalabs.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#5f9dff] mt-0.5 flex-shrink-0" />
                <a href="tel:+919266849651" className="text-gray-300 hover:text-white transition-colors duration-200 text-sm">
                  +91 9266849651
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#5f9dff] mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  IIT Alumni Network, India
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} Knowledge Ninja Lab. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#privacy" className="text-gray-400 hover:text-[#5f9dff] transition-colors duration-200">Privacy Policy</a>
              <a href="#terms" className="text-gray-400 hover:text-[#5f9dff] transition-colors duration-200">Terms of Service</a>
              <a href="#cookies" className="text-gray-400 hover:text-[#5f9dff] transition-colors duration-200">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };